// src/router/index.js
import Vue from 'vue'
import Router from 'vue-router'
import layout from '@/views/layout'
import index from '@/views/home/index'
import custom from '@/views/custom/index'

// 用户中心中心
import userCenter from '@/views/userCenter/userCenter'

// 引入权限守卫函数
import { createPermissionGuard } from '@/permission'

Vue.use(Router)

export const homePageRoutes = [
  // 我的订单
  {
    path: '/userHome',
    name: 'userHome',
    hidden: true,
    component: () => import('@/views/userCenter/userHome/userHome'),
    meta: {
      logoText: '',
      searchVisible: false,
      title: '我的首页'
    }
  },
  // 我的订单
  {
    path: '/myOrder',
    name: 'myOrder',
    parentMenu: '订单中心',
    component: () => import('@/views/userCenter/myOrder/myOrder'),
    meta: {
      logoText: '',
      searchVisible: false,
      title: '我的订单'
    }
  },
  // 我的评论
  {
    path: '/myEvaluate',
    name: 'myEvaluate',
    parentMenu: '订单中心',
    component: () => import('@/views/userCenter/myEvaluate/index'),
    meta: {
      logoText: '',
      searchVisible: false,
      title: '我的评价'
    }
  },
  // 我的分销
  {
    path: '/myDistribution',
    name: 'myDistribution',
    parentMenu: '订单中心',
    component: () => import('@/views/userCenter/myDistribution/myDistribution'),
    meta: {
      logoText: '',
      searchVisible: false,
      title: '我的分销'
    }
  },
  {
    path: '/orderAfterSale',
    name: 'orderAfterSale',
    parentMenu: '客户服务',
    component: () => import('@/views/userCenter/orderAfterSale/orderAfterSale'),
    meta: {
      logoText: '',
      searchVisible: false,
      title: '我的售后'
    }
  },
  {
    path: '/myInvoices',
    name: 'myInvoices',
    parentMenu: '客户服务',
    component: () => import('@/views/userCenter/myInvoices/myInvoices'),
    meta: {
      logoText: '',
      searchVisible: false,
      title: '我的发票'
    }
  },
  {
    path: '/qaList',
    name: 'qaList',
    parentMenu: '客户服务',
    component: () => import('@/views/userCenter/messageCenter/qaList'),
    meta: {
      logoText: '',
      searchVisible: false,
      title: '我的问答'
    }
  },
  {
    path: '/qalistDetails',
    name: 'qalistDetails',
    parentMenu: '客户服务',
    hidden: true,
    component: () => import('@/views/userCenter/messageCenter/qalistDetails'),
    meta: {
      logoText: '',
      searchVisible: false,
      title: '我的问答详情'
    }
  },
  // 优惠券商品
  {
    path: '/couponPackage',
    name: 'couponPackage',
    parentMenu: '我的钱包',
    component: () => import('@/views/userCenter/couponPackage/couponPackage'),
    meta: {
      logoText: '',
      searchVisible: false,
      title: '优惠券'
    }
  },
  {
    path: '/balance',
    name: 'balance',
    parentMenu: '我的钱包',
    component: () => import('@/views/userCenter/balance/balance'),
    meta: {
      logoText: '',
      searchVisible: false,
      title: '余额'
    }
  },
  {
    path: '/youbuCoin',
    name: 'youbuCoin',
    parentMenu: '我的钱包',
    component: () => import('@/views/userCenter/youbuCoin/youbuCoin'),
    meta: {
      logoText: '',
      searchVisible: false,
      title: '有有币'
    }
  },
  {
    path: '/browseRecords',
    name: 'browseRecords',
    parentMenu: '足迹与收藏',
    component: () => import('@/views/userCenter/browseRecords/browseRecords'),
    meta: {
      logoText: '',
      searchVisible: false,
      title: '浏览足迹'
    }
  },
  {
    path: '/favorites',
    name: 'favorites',
    parentMenu: '足迹与收藏',
    component: () => import('@/views/userCenter/favorites/favorites'),
    meta: {
      logoText: '',
      searchVisible: false,
      title: '我的收藏'
    }
  },
  {
    path: '/merchantOnboarding',
    name: 'merchantOnboarding',
    parentMenu: '消息通知',
    hidden: true,
    component: () => import('@/views/userCenter/notification/merchantOnboarding'),
    meta: {
      logoText: '',
      searchVisible: false,
      title: '商户入驻通知'
    }
  },
  {
    path: '/MerchantOnboardingDetail',
    name: 'MerchantOnboardingDetail',
    parentMenu: '消息通知',
    hidden: true,
    component: () => import('@/views/userCenter/notification/MerchantOnboardingDetail'),
    meta: {
      logoText: '',
      searchVisible: false,
      title: '商户入驻通知详情'
    }
  },
]
export const personRoutes = [
  // 我的名片
  {
    path: '/userBusinessCard',
    name: 'userBusinessCard',
    hidden: true,
    component: () => import('@/views/userCenter/userBusinessCard/userBusinessCard'),
    meta: {
      logoText: '',
      searchVisible: false,
      title: '我的名片'
    }
  },
  // 用户信息
 {
    path: '/userInfo',
    name: 'userInfo',
    parentMenu: '个人中心',
    component: () => import('@/views/userCenter/userInfo/userInfo'),
    meta: {
      logoText: '',
      searchVisible: false,
      title: '个人信息'
    }
  },
  // 地址
  {
    path: '/signingAddress',
    name: 'signingAddress',
    parentMenu: '个人中心',
    component: () => import('@/views/userCenter/signingAddress/signingAddress'),
    meta: {
      logoText: '',
      searchVisible: false,
      title: '收货地址'
    }
  },
// 账户安全
  {
    path: '/accountSecurity',
    name: 'accountSecurity',
    parentMenu: '个人中心',
    component: () => import('@/views/userCenter/accountSecurity/accountSecurity'),
    meta: {
      logoText: '',
      searchVisible: false,
      title: '账户安全'
    }
  },
]

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'layout',
      component: layout,
      children: [
        {
          path: '',
          alias: 'index',
          name: 'index',
          component: index,
          meta: {
            logoText: '',
            searchVisible: false
          }
        },
        // 自定义页面
        {
          path: '/custom',
          name: 'custom',
          component: custom,
          meta: {
            logoText: '',
            searchVisible: true
          }
        },
        // 用户中心
        {
          path: '/userCenter',
          name: 'userCenter',
          component: userCenter,
          meta: {
            logoText: '',
            searchVisible: false
          },
          children: [
            ...homePageRoutes,
            ...personRoutes,

            // 更换手机号
            {
              path: '/changePhone',
              name: 'changePhone',
              component: () => import('@/views/userCenter/changeInfo/changePhone'),
              meta: {
                logoText: '',
                searchVisible: false
              }
            },

            {
              path: '/message',
              name: 'message',
              component: () => import('@/views/userCenter/messageCenter/message'),
              meta: {
                logoText: '',
                searchVisible: false
              }
            },
          ]
        },
        // 活动页面
        {
          path: '/activity',
          name: 'activity',
          component: () => import('@/views/home/activity.vue'),
          meta: {
            logoText: '',
            searchVisible: true
          },
          children: [
            // 搜索
            {
              path: '/activity/search',
              name: 'search',
              component: () => import('@/views/search/index'),
              meta: {
                logoText: '',
                searchVisible: false,
                hiddenLogo: true
              }
            },
            // 分类页面
            {
              path: '/activity/category',
              name: 'category',
              component: () => import('@/views/category/index'),
              meta: {
                logoText: '',
                searchVisible: false,
                hiddenLogo: true
              }
            },
            // 优惠券商品
            {
              path: '/activity/couponProList',
              name: 'couponProList',
              component: () => import('@/views/promotions/couponProlist/index.vue'),
              meta: {
                logoText: '',
                searchVisible: false,
                hiddenLogo: true
              }
            },
            // 类别商品
            {
              path: '/canvasGoods',
              name: 'canvasGoods',
              component: () => import('@/views/canvasGoods/index'),
              meta: {
                logoText: '',
                searchVisible: false,
                hiddenLogo: true
              }
            },
            // 秒杀专区
            {
              path: '/activity/rabatt',
              name: 'rabatt',
              component: () => import('@/views/promotions/rabatt/index.vue'),
              meta: {
                logoText: '',
                searchVisible: false,
                hiddenLogo: true
              }
            },
            // 折扣专区
            {
              path: '/activity/spitze',
              name: 'spitze',
              component: () => import('@/views/promotions/spitze/index.vue'),
              meta: {
                logoText: '',
                searchVisible: false,
                hiddenLogo: true
              }
            },
            // 团购
            {
              path: '/activity/groupBuy',
              name: 'groupBuy',
              component: () => import('@/views/promotions/groupBuy/index.vue'),
              meta: {
                logoText: '',
                searchVisible: false,
                hiddenLogo: true
              }
            },
            // 领取优惠券
            {
              path: '/activity/coupon',
              name: 'coupon',
              component: () => import('@/views/promotions/coupon/index.vue'),
              meta: {
                logoText: '',
                searchVisible: false,
                hiddenLogo: true
              }
            },
            // vip专区
            {
              path: '/activity/vip',
              name: 'vip',
              component: () => import('@/views/promotions/vip/index.vue'),
              meta: {
                logoText: '',
                searchVisible: false,
                hiddenLogo: true
              }
            },
            // 组合捆绑
            {
              path: '/activity/bind',
              name: 'Bind',
              component: () => import('@/views/promotions/bind/index.vue'),
              meta: {
                logoText: '',
                searchVisible: false,
                hiddenLogo: true
              }
            },
            // 公告
            {
              path: '/activity/notificationDetails',
              name: 'notificationDetails',
              component: () => import('@/views/userCenter/messageCenter/notificationDetails'),
              meta: {
                logoText: '',
                searchVisible: false,
                hiddenLogo: true
              }
            }
          ]
        },
        // 店铺主页
        {
          path: '/store',
          name: 'store',
          component: () => import('@/views/store/index'),
          meta: {
            logoText: '',
            searchVisible: true
          }
        },
        // 评价
        {
          path: '/evaluate',
          name: 'evaluate',
          component: () => import('@/views/evaluate/index'),
          meta: {
            logoText: '',
            searchVisible: true
          }
        },
        // 购物车
        {
          path: '/shopping-trolley',
          name: 'shoppingTrolley',
          component: () => import('@/views/shopping-trolley/index'),
          meta: {
            logoText: '',
            searchVisible: true
          }
        },
        // 订单详情
        {
          path: '/orderDetail',
          name: 'orderDetail',
          component: () => import('@/views/orderDetail/index'),
          meta: {
            logoText: '',
            searchVisible: false
          }
        },
        // 商品详情
        {
          path: '/productDetail',
          name: 'productDetail',
          component: () => import('@/views/product/productDetail'),
          meta: {
            logoText: '',
            searchVisible: true
          }
        },
        // 下单页面
        {
          path: '/placeOrder',
          name: 'placeOrder',
          component: () => import('@/views/placeOrder/index'),
          meta: {
            logoText: '收银台',
            searchVisible: true
          }
        },
        // 支付结果页面——支付有礼
        {
          path: '/orderResult',
          component: () => import('@/views/placeOrder/orderResult.vue'),
          meta: {
            searchVisible: true
          }
        },
        {
          path: '/orderConfirm',
          name: 'orderConfirm',
          component: () => import('@/views/placeOrder/OrderConfirm.vue'),
          meta: {
            searchVisible: true
          }
        },
        // 售后
        {
          path: '/afterSale',
          name: 'afterSale',
          component: () => import('@/views/afterSale/index'),
          meta: {
            logoText: '',
            searchVisible: true
          }
        },
        // 评价详情
        {
          path: '/evaluateDetail',
          name: 'evaluateDetail',
          component: () => import('@/views/evaluateDetail/index'),
          meta: {
            logoText: '',
            searchVisible: true
          }
        },
        // 追评
        {
          path: '/addEvaluate',
          name: 'addEvaluate',
          component: () => import('@/views/addEvaluate/index'),
          meta: {
            logoText: '',
            searchVisible: true
          }
        },
        {
          path: '/customerService',
          name: 'customerService',
          component: () => import('@/views/home/customerService.vue'),
        },
        {
          path: '/templatePage',
          name: 'templatePage',
          component: () => import('@/views/templatePage/templatePage.vue'),
        },
        // 推广页
        {
          path: '/PromotionPage',
          name: 'PromotionPage',
          component: () => import('@/views/PromotionPage'),
          meta: {
            logoText: '',
            searchVisible: false
          }
        },
        // 平台规则
        {
          path: '/knowledgeRule',
          name: 'knowledgeRule',
          component: () => import('@/views/knowledgeRule'),
          meta: {
            logoText: '',
            searchVisible: false
          }
        },
        // 上新
        {
          path: '/liveStreamingRoom',
          name: 'liveStreamingRoom',
          component: () => import('@/views/zone/liveStreamingRoom'),
          meta: {
            logoText: '',
            searchVisible: false
          }
        },
        //食品茶酒
        {
          path: '/foodZone',
          name: 'foodZone',
          component: () => import('@/views/zone/foodZone'),
          meta: {
            logoText: '',
            searchVisible: false
          }
        },
        //服饰
        {
          path: '/costume',
          name: 'costume',
          component: () => import('@/views/zone/costume'),
          meta: {
            logoText: '',
            searchVisible: false
          }
        },
        //有有特价
        {
          path: '/specialOffer',
          name: 'specialOffer',
          component: () => import('@/views/zone/specialOffer'),
          meta: {
            logoText: '',
            searchVisible: false
          }
        },
         //有有资讯
        {
          path: '/information',
          name: 'information',
          component: () => import('@/views/zone/information'),
          meta: {
            logoText: '',
            searchVisible: false
          }
        },
        //资讯详情 
        {
          path: '/informationDetails',
          name: 'informationDetails',
          component: () => import('@/views/zone/informationDetails'),
          meta: {
            logoText: '',
            searchVisible: false
          }
        },

      ]
    },
  ]
})

const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

// 在创建 router 实例之后，调用权限守卫函数
createPermissionGuard(router)

// 保留原有的 beforeEach 用于其他用途（如果需要）
router.beforeEach((to, from, next) => {
  // cookie没有值就跳到登陆页
  // let area = sessionStorage.getItem('area')
  // if (area === null && to.name !== 'login' && to.name !== 'overview') {
  //   // Vue.prototype.$message.error('用户未登陆')
  //   next('/login')
  // } else {
  next()
  // }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js